import React from "react";
import { ICustomBaseMap } from "./BasemapWidget";

export interface IBaseMapButton {
    activeBasemapID: string;
    basemaps: any[];
    toggleExpanded: CallableFunction;
}
export const BaseMapButton = ({ activeBasemapID, basemaps, toggleExpanded }: IBaseMapButton): JSX.Element => {
    let secondmap = basemaps[1] as ICustomBaseMap;
    const index = basemaps.findIndex((map) => map.id === activeBasemapID);
    secondmap = (index === basemaps.length - 1 ? basemaps[0] : basemaps[index + 1]) as ICustomBaseMap;

    const basemapConfig = basemaps.find((bConfig) => bConfig.id === activeBasemapID);

    return (
        <>
            <img onClick={() => toggleExpanded()} src={basemapConfig.img} alt={basemapConfig.title} title={"open"} />
            <img className="backgroundMapImage" src={secondmap.img} alt={secondmap.title} />
        </>
    );
};
